var _filter, _filter2, _filter3, _rect, _rect2, _text, _g, _g2, _g3, _g4, _g5, _path, _text2, _g6, _g7, _g8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgA2AArchitecture(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 450",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "agent1Grad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#8b5cf6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#7c3aed"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "agent2Grad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#ec4899"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#db2777"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cardGrad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#06b6d4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#0891b2"
    }
  })), _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "shadowA2A"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 2,
    dy: 4,
    stdDeviation: 5,
    floodOpacity: 0.4
  }))), _filter2 || (_filter2 = /*#__PURE__*/React.createElement("filter", {
    id: "glowPurple"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6,
    result: "coloredBlur"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "coloredBlur"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })))), _filter3 || (_filter3 = /*#__PURE__*/React.createElement("filter", {
    id: "glowPink"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6,
    result: "coloredBlur"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "coloredBlur"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 450,
    fill: "#0f172a"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 20,
    width: 760,
    height: 410,
    rx: 20,
    fill: "#1e293b",
    opacity: 0.5
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 55,
    textAnchor: "middle",
    fill: "#e2e8f0",
    fontFamily: "Arial, sans-serif",
    fontSize: 22,
    fontWeight: "bold"
  }, "A2A Communication")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(180, 220)",
    filter: "url(#shadowA2A)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 75,
    fill: "none",
    stroke: "#8b5cf6",
    strokeWidth: 1,
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "75;85;75",
    dur: "3s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.3;0.1;0.3",
    dur: "3s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 60,
    fill: "url(#agent1Grad)",
    filter: "url(#glowPurple)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "60;63;60",
    dur: "2s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("rect", {
    x: -25,
    y: -20,
    width: 50,
    height: 35,
    rx: 8,
    fill: "#1e1b4b",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -12,
    cy: -8,
    r: 6,
    fill: "#a5f3fc"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0.5;1",
    dur: "1.5s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: -8,
    r: 6,
    fill: "#a5f3fc"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0.5;1",
    dur: "1.5s",
    repeatCount: "indefinite",
    begin: "0.2s"
  })), /*#__PURE__*/React.createElement("rect", {
    x: -15,
    y: 5,
    width: 30,
    height: 4,
    rx: 2,
    fill: "#a5f3fc"
  }), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 90,
    textAnchor: "middle",
    fill: "#c4b5fd",
    fontFamily: "Arial, sans-serif",
    fontWeight: "bold",
    fontSize: 14
  }, "Research Agent"), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 108,
    textAnchor: "middle",
    fill: "#94a3b8",
    fontFamily: "Arial, sans-serif",
    fontSize: 11
  }, "Gathers information"))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(620, 220)",
    filter: "url(#shadowA2A)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 75,
    fill: "none",
    stroke: "#ec4899",
    strokeWidth: 1,
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "75;85;75",
    dur: "3s",
    repeatCount: "indefinite",
    begin: "0.5s"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.3;0.1;0.3",
    dur: "3s",
    repeatCount: "indefinite",
    begin: "0.5s"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 60,
    fill: "url(#agent2Grad)",
    filter: "url(#glowPink)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "60;63;60",
    dur: "2s",
    repeatCount: "indefinite",
    begin: "0.5s"
  })), /*#__PURE__*/React.createElement("rect", {
    x: -25,
    y: -20,
    width: 50,
    height: 35,
    rx: 8,
    fill: "#4a044e",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -12,
    cy: -8,
    r: 6,
    fill: "#fbcfe8"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0.5;1",
    dur: "1.5s",
    repeatCount: "indefinite",
    begin: "0.3s"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: -8,
    r: 6,
    fill: "#fbcfe8"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0.5;1",
    dur: "1.5s",
    repeatCount: "indefinite",
    begin: "0.5s"
  })), /*#__PURE__*/React.createElement("rect", {
    x: -15,
    y: 5,
    width: 30,
    height: 4,
    rx: 2,
    fill: "#fbcfe8"
  }), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 90,
    textAnchor: "middle",
    fill: "#f9a8d4",
    fontFamily: "Arial, sans-serif",
    fontWeight: "bold",
    fontSize: 14
  }, "Writing Agent"), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 108,
    textAnchor: "middle",
    fill: "#94a3b8",
    fontFamily: "Arial, sans-serif",
    fontSize: 11
  }, "Creates content"))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(400, 220)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -130,
    y: -25,
    width: 260,
    height: 50,
    rx: 25,
    fill: "#1e293b",
    stroke: "#475569",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: -100,
    y1: -8,
    x2: 100,
    y2: -8,
    stroke: "#8b5cf6",
    strokeWidth: 3,
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dasharray",
    values: "0,200;200,200",
    dur: "2s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 8,
    x2: -100,
    y2: 8,
    stroke: "#ec4899",
    strokeWidth: 3,
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dasharray",
    values: "0,200;200,200",
    dur: "2s",
    repeatCount: "indefinite",
    begin: "0.5s"
  })), /*#__PURE__*/React.createElement("circle", {
    r: 8,
    fill: "#8b5cf6"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cx",
    values: "-100;100",
    dur: "1.5s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "cy",
    values: "-8;-8",
    dur: "1.5s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;1;0",
    dur: "1.5s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    r: 8,
    fill: "#ec4899"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cx",
    values: "100;-100",
    dur: "1.5s",
    repeatCount: "indefinite",
    begin: "0.75s"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "cy",
    values: "8;8",
    dur: "1.5s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;1;0",
    dur: "1.5s",
    repeatCount: "indefinite",
    begin: "0.75s"
  })), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 55,
    textAnchor: "middle",
    fill: "#94a3b8",
    fontFamily: "Arial, sans-serif",
    fontSize: 12
  }, "A2A Protocol"))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(180, 370)",
    filter: "url(#shadowA2A)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -60,
    y: -25,
    width: 120,
    height: 50,
    rx: 8,
    fill: "#0e7490",
    stroke: "#06b6d4",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-opacity",
    values: "0.5;1;0.5",
    dur: "2s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: -5,
    textAnchor: "middle",
    fill: "white",
    fontFamily: "Arial, sans-serif",
    fontWeight: "bold",
    fontSize: 11
  }, "Agent Card"), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 12,
    textAnchor: "middle",
    fill: "#a5f3fc",
    fontFamily: "Arial, sans-serif",
    fontSize: 9
  }, "capabilities, endpoints"), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: -30,
    x2: 0,
    y2: -80,
    stroke: "#06b6d4",
    strokeWidth: 2,
    strokeDasharray: "4,3"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    values: "0;-14",
    dur: "0.5s",
    repeatCount: "indefinite"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(620, 370)",
    filter: "url(#shadowA2A)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -60,
    y: -25,
    width: 120,
    height: 50,
    rx: 8,
    fill: "#0e7490",
    stroke: "#06b6d4",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-opacity",
    values: "0.5;1;0.5",
    dur: "2s",
    repeatCount: "indefinite",
    begin: "0.5s"
  })), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: -5,
    textAnchor: "middle",
    fill: "white",
    fontFamily: "Arial, sans-serif",
    fontWeight: "bold",
    fontSize: 11
  }, "Agent Card"), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 12,
    textAnchor: "middle",
    fill: "#a5f3fc",
    fontFamily: "Arial, sans-serif",
    fontSize: 9
  }, "capabilities, endpoints"), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: -30,
    x2: 0,
    y2: -80,
    stroke: "#06b6d4",
    strokeWidth: 2,
    strokeDasharray: "4,3"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    values: "0;-14",
    dur: "0.5s",
    repeatCount: "indefinite"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M250,370 Q400,420 550,370",
    fill: "none",
    stroke: "#22d3ee",
    strokeWidth: 2,
    strokeDasharray: "6,4"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    values: "0;-20",
    dur: "1s",
    repeatCount: "indefinite"
  }))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 405,
    textAnchor: "middle",
    fill: "#22d3ee",
    fontFamily: "Arial, sans-serif",
    fontSize: 10
  }, "Discovery")), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(280, 130)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -50,
    y: -20,
    width: 100,
    height: 40,
    rx: 15,
    fill: "#8b5cf6",
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0;0.9;0.9;0",
    dur: "4s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "-30,20 -20,20 -25,30",
    fill: "#8b5cf6"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0;0.9;0.9;0",
    dur: "4s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 5,
    textAnchor: "middle",
    fill: "white",
    fontFamily: "Arial, sans-serif",
    fontSize: 11
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0;1;1;0",
    dur: "4s",
    repeatCount: "indefinite"
  }), "\n      Found data!\n    "))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(520, 130)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -50,
    y: -20,
    width: 100,
    height: 40,
    rx: 15,
    fill: "#ec4899",
    opacity: 0
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0;0;0.9;0.9;0",
    dur: "4s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "30,20 20,20 25,30",
    fill: "#ec4899"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0;0;0.9;0.9;0",
    dur: "4s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 5,
    textAnchor: "middle",
    fill: "white",
    fontFamily: "Arial, sans-serif",
    fontSize: 11
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0;0;1;1;0",
    dur: "4s",
    repeatCount: "indefinite"
  }), "\n      Writing it!\n    "))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(400, 430)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: -120,
    cy: 0,
    r: 6,
    fill: "#8b5cf6"
  }), /*#__PURE__*/React.createElement("text", {
    x: -105,
    y: 4,
    fill: "#94a3b8",
    fontFamily: "Arial, sans-serif",
    fontSize: 10
  }, "Agent"), /*#__PURE__*/React.createElement("rect", {
    x: -60,
    y: -6,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#0e7490"
  }), /*#__PURE__*/React.createElement("text", {
    x: -40,
    y: 4,
    fill: "#94a3b8",
    fontFamily: "Arial, sans-serif",
    fontSize: 10
  }, "Agent Card"), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 0,
    x2: 50,
    y2: 0,
    stroke: "#ec4899",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 4,
    fill: "#94a3b8",
    fontFamily: "Arial, sans-serif",
    fontSize: 10
  }, "Communication"))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgA2AArchitecture);
export default __webpack_public_path__ + "static/media/a2a-architecture.6f44a4c66d4972d82a422a5ee78ac4f3.svg";
export { ForwardRef as ReactComponent };